import ImagesCaroussel from "../../components/assets/ImagesCaroussel";
import { useMediaQuery } from "react-responsive";
import YellowEye from "../../components/assets/eyes/YellowEye";
import BlueEye from "../../components/assets/eyes/BlueEye";
import PinkEye from "../../components/assets/eyes/PinkEye";
import Arrow from "../../components/assets/Arrow";
import SquareMosaic from "../../components/assets/mosaics/SquareMosaic";
import TargetMosaic from "../../components/assets/mosaics/TargetMosaic";
import TriangleMosaic from "../../components/assets/mosaics/TriangleMosaic";
import QuarterCircleMosaic from "../../components/assets/mosaics/QuarterCircleMosaic";
import HalfCircleMosaic from "../../components/assets/mosaics/HalfCircleMosaic";
import ArrowUpRightMosaic from "../../components/assets/mosaics/ArrowUpRightMosaic";
import StarMosaic from "../../components/assets/mosaics/StarMosaic";
import OvalMosaic from "../../components/assets/mosaics/OvalMosaic";
import EyeMosaic from "../../components/assets/mosaics/EyeMosaic";
import HalfTriangleMosaic from "../../components/assets/mosaics/HalfTriangleMosaic";
import LineMosaic from "../../components/assets/mosaics/LineMosaic";
import BigLineMosaic from "../../components/assets/mosaics/BigLineMosaic";
import clsx from "clsx";
import { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../globals";
import Loader from "../../components/assets/Loader";
import gsap from "gsap";

function LandingGridCaroussel() {
    const [images,setImages] = useState([]);
    const [isLoading,setIsLoading] = useState(true);

    async function fetchImages(){
        setIsLoading(true);
        const post_type = "realisation";
        const limit = 3;
        try {
            const response = await axios.get(`${BASE_URL}/${post_type}?orderby=rand&per_page=${limit}&_=${gsap.utils.random(1,1000)}`);
            const data = response.data;
            for(let post of data){
                if(post.featured_media === 0){
                    console.log(post);
                }
                const mediaData = await axios.get(`${BASE_URL}/media/${post.featured_media}`);
                post.thumbnail = {
                    src: mediaData.data.source_url,
                    alt: mediaData.data.alt_text
                }
            }
            setImages([...data].map(post=>post.thumbnail));

        } catch(err){
            console.log(err);
        }
        setIsLoading(false);
    }

    useEffect(()=>{
        fetchImages();
    },[]);
    

    return (
        <div className="overflow-hidden flex justify-center items-center">
            {isLoading ? <Loader/> : <ImagesCaroussel
                images={images} />}
        </div>
    )
}

function LandingGridCenter({
    isMobile,
    isTablet,
    isSmallComputer,
    isVerySmallComputer
}) {
    return (
        <div className={clsx(
            "flex justify-center items-center relative overflow-hidden w-full col-span-4",
            isMobile ? "row-span-3 aspect-[4/3]" : "row-span-2 aspect-[4/2]"
        )}>
            <div className={clsx(
                "font-[800] flex flex-col leading-[100%]",
                (!isMobile && !isTablet && !isSmallComputer) && "text-big-heading",
                isSmallComputer && "text-[7rem] mobile:text-[5.27rem]"
            )}>
                <div className="flex gap-[1.5rem] relative w-fit">
                    <span className="ml-[5.5625rem] mobile:ml-[3rem]">Voir</span>
                    <div className="w-[6.5625rem] aspect-square mobile:w-[4rem]">
                        <YellowEye />
                    </div>
                    <div className="w-[7.5rem] absolute left-full top-1/4 translate-x-1/4 rotate-[6deg] mobile:w-[4.54rem]">
                        <Arrow />
                    </div>
                </div>
                <span>plus loin</span>
                <span className="ml-[5.5625rem] mobile:ml-[3rem]">ensemble.</span>
            </div>
            <div className="absolute bottom-0 left-0 w-[8.75rem] aspect-square mobile:w-[5.27rem]">
                <PinkEye version={2}/>
            </div>
            <div className="absolute right-[1rem] top-1/2 -translate-y-1/2 w-[9.0625em] aspect-square rotate-[-19deg] mobile:w-[5.5rem]">
                <BlueEye />
            </div>

        </div>
    )
}

const globalGridItems = [
    <div>
        <SquareMosaic />
    </div>,
    <div>
        <TargetMosaic />
    </div>,
    <LandingGridCaroussel key={1}/>,
    <div>
        <TriangleMosaic />
    </div>,
    <div>
        <QuarterCircleMosaic />
    </div>,
    <LandingGridCaroussel key={2}/>,
    <div>
        <HalfCircleMosaic />
    </div>,
    <div>
        <ArrowUpRightMosaic />
    </div>,
    <div>
        <StarMosaic />
    </div>,
    <div>
        <OvalMosaic />
    </div>,
    <div>
        <EyeMosaic />
    </div>,
    <LandingGridCaroussel key={3}/>,
    <LandingGridCaroussel key={4}/>,
    <LandingGridCaroussel key={5}/>,
    <div>
        <TargetMosaic />
    </div>,
    <div>
        <HalfTriangleMosaic />
    </div>,
    <div>
        <SquareMosaic />
    </div>,
    <LandingGridCaroussel/>,
    <div>
        <LineMosaic />
    </div>,
    <div>
        <QuarterCircleMosaic />
    </div>,
    <LandingGridCaroussel key={6}/>,
    <div>
        <HalfTriangleMosaic />
    </div>,
    <div>
        <BigLineMosaic />
    </div>,
    <LandingGridCaroussel key={7}/>,
]

export default function LandingGrid() {
    const isMobile = useMediaQuery(
        {
            query: "(max-width: 780px)"
        }
    )

    const isTablet = useMediaQuery(
        {
            query: "(max-width: 1000px)"
        }
    )

    const isVerySmallComputer = useMediaQuery(
        {
            query: "(max-width: 1280px)"
        }
    )

    const isSmallComputer = useMediaQuery(
        {
            query: "(max-width : 1600px)"
        }
    )


    function getGridColumns() {
        if (isTablet) {
            return 4;
        } else if (isVerySmallComputer) {
            return 5;
        } else if (isSmallComputer) {
            return 6
        } else {
            return 8
        }
    }

    const [gridColumns, setGridColumns] = useState(getGridColumns());

    const [gridItems,setGridItems] = useState(getGridItems());

    useEffect(() => {
        setGridColumns(getGridColumns());
        setGridItems(getGridItems());
    }, [isMobile, isTablet, isSmallComputer, isVerySmallComputer]);

    function getGridItems() {
        const landingContainer = <LandingGridCenter isMobile={isMobile} isTablet={isTablet} isSmallComputer={isSmallComputer} isVerySmallComputer={isVerySmallComputer} />;
        if (isMobile) {
            return [
                ...globalGridItems.slice(0, 12),
                landingContainer,
                ...globalGridItems.slice(12, 24)
            ];
        } else if (isTablet) {
            return [
                ...globalGridItems.slice(0, 4),
                landingContainer,
                ...globalGridItems.slice(4, 8)
            ];
        } else if (isVerySmallComputer) {
            return [
                ...globalGridItems.slice(0, 5),
                landingContainer,
                ...globalGridItems.slice(12, 19)
            ];
        } else if (isSmallComputer) {
            return [
                ...globalGridItems.slice(0, 6),
                landingContainer,
                ...globalGridItems.slice(2, 12)
            ];
        } else {
            return [
                ...globalGridItems.slice(0, 9),
                landingContainer,
                ...globalGridItems.slice(9, 24)
            ];
        }

    }

    return (
        <div
            className="w-full h-dvh flex flex-col justify-center mobile:justify-center overflow-hidden"
        >
            <div className="grid [&_img]:object-cover [&>svg]:aspect-square" style={
                {
                    gridTemplateColumns: `repeat(${gridColumns},1fr)`
                }
            }>
                {gridItems.map(v => v)}
            </div>
        </div>
    )
}